module.exports = __webpack_public_path__ + "github_logo.18cbb654a45cdc6d344f7eeeaea22996.png";